import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import "./enrolmentInfo.css";
import {
  addNoteForEnrolmentCancelled,
  updateEnrolmentAction,
} from "../../pages/enrolment/enrolmentAction";

import { NoData } from "../no-data/NoData";
import { UpdateEnrolment } from "./UpdateEnrolment";
import { toggleModelBox } from "../../systemSlice";
import { useParams } from "react-router-dom";

const EnrolmentInfo = () => {
  const dispatch = useDispatch();
  const { _id } = useParams();
  const { user } = useSelector((state) => state.user);
  const { enrollments } = useSelector((state) => state.enroll);
  const enrolment = enrollments.find((enrollment) => enrollment._id === _id);
  const params = new URLSearchParams();
  params.set("branch", user?.branch);
  const par = params.toString();

  if (!enrolment?._id) {
    return <NoData />;
  }

  const updateEnrolment = (e) => {
    dispatch(toggleModelBox());
  };

  const cancelEnrolment = () => {
    if (!_id) return;

    if (
      window.confirm(
        "Are you sure you want to cancel this enrolment and delete all existing payment records?"
      )
    ) {
      dispatch(
        updateEnrolmentAction(_id, {
          ...enrolment,
          params: par,
          progress: "cancelled",
          status: false,
          payment: {
            paidFull: false,
            paidDate: new Date(),
            status: "cancelled",
            installment: [...enrolment?.payment?.installment],
          },
        })
      ) &&
        dispatch(
          addNoteForEnrolmentCancelled({
            _id,
            params: par,
            message: "Enrolment cancelled",
          })
        );
    }
  };

  const removeDiscount = (discountId) => {
    if (!_id || !discountId) return;

    if (
      window.confirm(
        "Are your sure you want to remove the discount amount from this enrolment?"
      )
    ) {
      dispatch(updateEnrolmentAction(_id, { params: par, discountId }));
    }
  };

  // const createStudentAccount = () => {
  //   if (!_id) return

  //   if (
  //     window.confirm(
  //       "Are you sure you want to create a student account for this enrolment?"
  //     )
  //   ) {
  //     dispatch(createStudentAccountAction({ student: enrolment })) &&
  //       dispatch(
  //         addNoteFromEnrolment({
  //           _id,
  //           message: "A student account for this enrolment has been created!",
  //         })
  //       )
  //   }
  // }

  // const generateCertificate = async () => {
  //   const { fName, lName, course, _id } = enrolment
  //   const data = { fName, lName, course, _id }

  //   const res = await pdfApi.fetchPDF(data)

  //   if (res.status === "success") {
  //     toast.success(res.message)
  //   }
  // }

  const totalDiscount = enrolment.discount?.reduce((a, c) => a + c.amount, 0);
  const totalFee = enrolment.fees?.originalFee - totalDiscount;

  return (
    <Container>
      <UpdateEnrolment title="Update Enrolment" show={true} />

      <Row className="courseInfo  mt-3">
        <h4 className="enrolInfo d-flex justify-content-between text-primary">
          <span> Enrolment Info</span>{" "}
          <span className="edit" onClick={updateEnrolment}>
            <i className="fas fa-edit"></i>
          </span>
        </h4>
        <hr />

        <Col md={6}>
          <div>
            <b>
              <u>User</u>
            </b>
            <h6>
              Name: &nbsp;
              <b>
                {enrolment?.fName}&nbsp;{enrolment?.lName}
              </b>
            </h6>
            <h6>
              Mobile: &nbsp; <b>{enrolment?.mobile}</b>
            </h6>
            <h6>
              Email: &nbsp; <b>{enrolment?.email}</b>
            </h6>
          </div>

          <div>
            <b>
              <u>Course</u>
            </b>
            <h6>
              Enrolment ID: <b>{enrolment?.enrolId}</b>
              <br />
            </h6>
            <h6>
              Course title : <b>{enrolment?.course?.name}</b>
            </h6>
            <h6>
              Course Code: <b>{enrolment?.course?.courseCode}</b>
            </h6>

            <h6>
              Courses Study Period:{" "}
              <b>
                {new Date(enrolment?.course?.commenceDate).toLocaleDateString()}{" "}
                - {new Date(enrolment?.course?.endDate).toLocaleDateString()}
              </b>
            </h6>

            <h6>
              Courses Days: <b>{enrolment?.classGroup}</b>
            </h6>
          </div>
        </Col>

        <Col
          md="6"
          className="d-flex flex-column justify-content-between align-items-baseline"
        >
          <div>
            <h6>
              Status:{" "}
              <b
                className={
                  enrolment?.progress === "cancelled"
                    ? "text-danger"
                    : enrolment?.progress === "complete"
                    ? "text-success"
                    : "text-info"
                }
              >
                {(enrolment?.progress).toUpperCase()}
              </b>
            </h6>

            <h6>
              Location:{" "}
              <b style={{ textTransform: "capitalize" }}>
                {enrolment?.location}
              </b>
            </h6>
            <h6>
              Full Fees: <b>${enrolment?.fees?.originalFee}</b>
            </h6>

            <h6>
              Total Fee:{" "}
              <b>
                $
                {enrolment.fees?.discountAmount
                  ? enrolment.fees?.discountAmount
                  : totalFee}
              </b>
            </h6>
            <h6>
              Discounts:{" "}
              <Table
                responsive
                striped
                bordered
                hover
                className="text-center mt-2 mb-5"
                style={{ fontSize: "12px" }}
              >
                <thead className="bg-info">
                  <tr>
                    <th>#</th>
                    <th>Label</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {enrolment.discount?.map((d, i) => (
                    <tr key={d._id}>
                      <td>{i + 1}</td>
                      <td>{d.label}</td>
                      <td>${d.amount}</td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => removeDiscount(d._id)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>#</td>
                    <td>
                      <b className="fs-6">Total</b>
                    </td>
                    <td>
                      <b className="fs-6">${totalDiscount}</b>
                    </td>
                    <td>---</td>
                  </tr>
                </tbody>
              </Table>
            </h6>
            {/* {enrolment?.referralCode && (
              <>
                <h6>
                  Discounted Fees: <b>${enrolment.fees?.discountedFee}</b>
                </h6>
                <h6>
                  Discount Amount:
                  <b>
                    $
                    {enrolment.fees?.discountAmount
                      ? enrolment.fees?.discountAmount
                      : enrolment.discount[0]?.amount || 0}
                  </b>
                </h6>
                <h6>
                  Referral Code: <b>{enrolment.referralCode}</b>
                </h6>
              </>
            )} */}
          </div>
        </Col>

        <div className="d-flex justify-content-around">
          {/* <button
            className="btn btn-success stu-btn"
            style={{ letterSpacing: "2px", fontSize: "20px" }}
            onClick={() => createStudentAccount()}
          >
            Create Account
          </button> */}
          {enrolment.progress === "complete" &&
            enrolment?.certificate !== "" && (
              <a
                href={enrolment.certificate}
                className="btn btn-info stu-btn"
                style={{ letterSpacing: "2px", fontSize: "20px" }}
              >
                Download Certificate
              </a>
            )}

          {enrolment.progress !== "complete" && (
            <button
              className="btn btn-warning cancel-btn"
              style={{ letterSpacing: "2px", fontSize: "20px" }}
              onClick={() => cancelEnrolment()}
              disabled={enrolment.status === false}
            >
              {enrolment.status === false
                ? "Enrolment Cancelled"
                : "Refund & Cancel Enrolment"}
            </button>
          )}
        </div>
      </Row>
    </Container>
  );
};

export default EnrolmentInfo;
